/* eslint-disable lines-between-class-members */
/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
import { Controller } from "@hotwired/stimulus";
import { experiment } from "../../packs/utils/amplitude";

export default class extends Controller {
  static targets = ["cover"];

  FEATURE_FLAG = "20240612-course-card-image-in-feed";
  oldPattern = "course-covers";
  newPattern = "course-open-graph-covers";
  stgURL = "https://dmstk-stg-res.cloudinary.com/";
  prodURL = "https://cdn.domestika.org/";

  async connect() {
    if (this.coverTargets.length > 0) {
      await experiment.start();
      this.variant = experiment.variant(this.FEATURE_FLAG);

      if (this.variant?.value === "treatment") {
        this.coverTargets.forEach((cover) => this.handleReplace(cover));
      }

      this.coverTargets.forEach((cover) => this.handleLoading(cover));
    }
  }

  handleReplace(cover) {
    cover.querySelectorAll("picture source, picture img").forEach((el) => {
      if (el.srcset && el.srcset.includes(this.oldPattern)) {
        el.srcset = el.srcset
          .replace(new RegExp(this.oldPattern, "g"), this.newPattern)
          .replace(this.stgURL, this.prodURL);
      }
      if (el.src && el.src.includes(this.oldPattern)) {
        el.src = el.src
          .replace(new RegExp(this.oldPattern, "g"), this.newPattern)
          .replace(this.stgURL, this.prodURL);
      }
    });
  }

  handleLoading(cover) {
    const img = cover.querySelector("picture img");
    if (img.complete) {
      cover.classList.remove("loading");
    } else {
      img.addEventListener("load", () => cover.classList.remove("loading"));
      setTimeout(() => cover.classList.remove("loading"), 3000);
    }
  }
}
